import { memo } from "react";
import { Box, Typography, Paper } from "@mui/material";

import { useUserState } from "../../../Context/UserContext";

const TotalsDisplay = memo((props) => {
  const { user } = useUserState();
  return (
    <Paper
      sx={{
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
        boxShadow: 2,
        marginTop: "1rem",
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Time: {props.time} Days
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Jobs: {props.jrCount}
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Total invoice amount: ${props.totalInvoiceCharge.toFixed(2)}
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {user.vendorMode ? "Total Received amount:" : " Total Paid amount:"}$
          {props.totalReceivedAmount.toFixed(2)}
        </Typography>
      </Box>

      <Box>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Balance: $
          {(props.totalInvoiceCharge - props.totalReceivedAmount).toFixed(2)}
        </Typography>
      </Box>
    </Paper>
  );
});

export default TotalsDisplay;
